import { superAxios } from "./superAxios";
var OcelotService="PayService";


//支付宝生成Code
 export const AlipayAbnormalForOrderPay = async (params: any) => {
    
   const res = await (
     await superAxios.useWebAPI(OcelotService)
   ).post({
     url: "app/MayfocusOnlinePayment/AlipayAbnormalForOrderPay",
     params
   });
    
   return res;
 };